<template>
    <div class="pa-2">
        <!-- delete dialog -->
        <v-delete-dialog
			v-model="deleteDialog"
			:module="'users/delete'"
			:parameters="{ id: itemId ? itemId : null }"
			@on-delete="getAll()">
			<!-- {{ $T('users.delete-message') }} -->
              هل أنت متأكد من أنك تريد حذف هذا المستخدم؟
		</v-delete-dialog>

        <!-- dialog -->
        <v-dialog
			v-model="dialog"
			max-width="550px"
			transition="dialog-transition"
        >
			<v-card>
				<v-card-title primary-title>
					إضافة مستخدم
					<v-spacer></v-spacer>
					<v-btn
						@click="dialog = false"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<v-row dense>
                        <v-col cols="6">
                            <v-autocomplete
                                v-model="employeeId"
                                :items="employees"
                                :item-text="item => `(${item.code}) ${item.arabicFullName}`"
							    item-value="employeeId"
                                dense 
                                outlined
                                :return-object="false"
							    :label="$T('employee')"
                                hide-details
                                :disabled="itemId"
                            />
                        </v-col>

                        <v-col cols="6">
                            <v-autocomplete
                                v-model="roleId"
                                label="الدور الوظيفي"
                                :items="roles"
                                item-text="name"
                                item-value="id"
                                dense 
                                outlined
                                hide-details
                            />
                        </v-col>

                        <v-col cols="6">
                            <v-text-field
                                v-model="username"
                                dense 
                                outlined
                                hide-details
                                label="اسم المستخدم"
                            />
                        </v-col>
                        
                        <v-col cols="6">
                            <v-text-field
                                v-model="password"
                                dense 
                                outlined
                                hide-details
                                label="كلمة المرور"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                prepend-icon="mdi-lock"
                                @click:append="showPassword = !showPassword"
                                :type="showPassword ? 'text' : 'password'"
                            />
                        </v-col>

                        <v-col cols="12">
                           نوع صلاحيات المستخدم: 
                            <v-radio-group
                                v-model="userType"
                                row
                                hide-details
                                dense
                                class="d-flex justify-start mt-0 mb-2 mx-0"

                            >
                                <v-radio label="مستخدم على الموبايل" :value="0" class="" color="success"/>
                                <v-radio label="مستخدم على النظام" :value="1" class="" color="success"/>
                                
                            </v-radio-group>
                        </v-col>

                        <v-col>
                            <v-switch :disabled="itemId" v-model="isActive" label="فعال"  hide-details class="mt-0" />
                        </v-col>

                        <v-col cols="6">
                            <v-checkbox 
                                v-model="isAdmin"
                                label="مشرف" 
                                class="mt-0"
                                hide-details
                                :disabled="itemId"
                            />
                        </v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="align-center pb-1">
					<v-spacer></v-spacer>
					<v-btn
						color="secondary"
						:disabled="loadingAdding"
						:loading="loadingAdding"
						@click="createOrEdit()">
						{{ $T('default-buttons.save') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
        <v-row>
            <v-spacer />
            <v-col cols="auto">
				<v-btn
					@click="dialog = true"
					small
					color="primary">
					<v-icon left> $add </v-icon>
					{{ $T('add') }}
				</v-btn>
			</v-col>
        </v-row>
        <bee-handy-table 
            :headers="headers"
            :items="users"
            dense
            zebra
            :items-per-page="-1"
            hide-default-footer
            class="mt-2"
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <tooltip :text="$T('tooltips.edit')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; dialog = true"
                            >
                            <v-icon
                                size="20"
                                color="edit-color">
                                $edit
                            </v-icon>
                        </v-btn>
                    </tooltip>

                    <tooltip :text="$T('tooltips.delete')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; deleteDialog = true"
                            >
                            <v-icon
                                size="20"
                                color="alert-color  ">
                                $delete
                            </v-icon>
                        </v-btn>
                    </tooltip>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    watch: {
        dialog(val) {
            if(val && this.itemId !== null) {
                // get name for employee
                this.employeeId = this.getById(this.itemId)?.employeeId
                // get role name
                this.roleId = this.getById(this.itemId)?.role.id
                this.isAdmin = this.getById(this.itemId)?.isAdmin
                this.username = this.getById(this.itemId)?.username
                this.password = this.getById(this.itemId)?.password
                this.userType = this.getById(this.itemId)?.userType
                this.isActive = this.getById(this.itemId)?.isActive
            } else {
                this.itemId = null

                this.roleId = null
                this.isAdmin = null
                this.username = null
                this.password = null
                this.userType = null
                this.isActive = null
            }
        }
    },
    data () {
        return {
            loading: false,
            loadingAdding: false,
            itemId: null,
            deleteDialog: false,
            languages: [],
            dialog: false,
            name: null,
            showPassword: false,
            employeeId: null, 
            roleId: null, 
            isAdmin: false, 
            username: null,
            password: null,
            userType: 0, 
            isActive: true
        }
    },

    computed: {
        ...mapState({
            users: state => state.users.users,
            employees: (state) => state.employee.employees,
            positions: state => state.positions.positions,
            roles: state => state.roles.roles
        }),

        ...mapGetters({
            getById: 'users/getById'
        }),

        headers() {
            return [
                {
                    text: 'اسم الموظف',
                    name: 'employeeId',
                    value: 'employeeId',
                    setValueExpr: val => this.employees.find(c => c.employeeId === val)?.arabicFullName
                },
                {
                    text: 'اسم المستخدم',
                    name: 'username',
                    value: 'username'
                },
                {
                    text: 'المسمى الوظيفي',
                    name: 'role',
                    value: 'role',
                    setValueExpr: val => val.name
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ]
        }
    },

    methods: {
        createOrEdit () {
            this.loadingAdding = true
            const actionName = this.itemId ? 'update' : 'create'
            this.$store.dispatch(`users/${actionName}`, { 
                employeeId: this.employeeId, 
                roleId: this.roleId,
                isAdmin: this.isAdmin,
                username: this.username, 
                password: this.password, 
                userType: this.userType, 
                isActive: this.isActive,
                id: this.itemId ? this.itemId : null
            }).then(() => {
                this.getAll()
            }).finally(() => {
                this.loadingAdding = false
                this.loading = false
                this.dialog = false
            })
        },

        getAll() {
            this.loading = true
            return this.$store.dispatch('users/fetchAll').finally(() => {
                this.loading = false
            })
        }
    },

    created() {
        this.getAll()
        this.$store.dispatch('roles/fetchAll')
        // this.$store.di
    }
}
</script>
